import * as React from "react";
import { FC, useState } from 'react';
import { Meeting } from "../../model/meeting";
import IndexedListColorManager from "../../services/IndexedListColorManager";
import { Rx } from "../../services/Rx";
import "./MeetingHeader.css";
import TImeManager from "../../services/TImeManager";
import { Button, Dialog, DialogContent, DialogTitle, TextField } from "@material-ui/core";
import WordsManager from "../../services/WordsManager";
import Firebaser from "../../services/Firebaser";

export const MeetingHeader: FC = () => {

	const [meeting, setMeeting] = React.useState<Meeting>();
	React.useEffect(() => {
		Rx.ChosenMeeting.subscribe(value => setMeeting(value));
	}, []);

	const speakers = meeting?.metadata?.participants || new Set<string>();

	const [speakerToRename, setSpeakerToRename] = useState("");
	const [newName, setNewName] = useState("");

	const onClick = () => {
		if(newName === speakerToRename){
			setNewName('');
			setSpeakerToRename('');
			return;
		}

		if(speakers.has(newName)){
			alert('this name already exists for different speaker, choose another');
			setNewName('');
			return;
		}

		WordsManager.renameSpeaker(speakerToRename, newName);
		setNewName('');
		setSpeakerToRename('');
	};

	const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
		if (event.key === 'Enter') {
			event.preventDefault();
			event.stopPropagation();
		}

		if(event.key === 'Escape')
			setSpeakerToRename('');
	};

	if (!meeting)
		return <></>;

	return (
		<div className="rowFlex header">
			<div className="columnFlex">
				<div className="columnFlex">
					<div className="rowFlex">
						<span className="meetingNameHeader">שם הפגישה: &nbsp;<b>{meeting.metadata.name}</b></span>
						{meeting.metadata.price ? <span className="meetingPriceHeader">תשלום: &nbsp;<b>{meeting.metadata.price}₪</b></span> : null}
						{meeting.metadata.knowledge ? <span className="meetingKnowledge">תחומי דעת: &nbsp;<b>{meeting.metadata.knowledge}</b></span> : null}
					</div>
					<div className="rowFlex">
						<span className="uploadMeetingDateHeader">תאריך:&nbsp;<b>{TImeManager.getDateString(meeting.metadata.date)}</b></span>
						<span className="ownerNameHeader">שם מעלה ההקלטה: &nbsp;<b>{meeting.metadata.ownerName}</b></span>
						<span className="ownerPhoneHeader">טלפון: &nbsp;<b>{meeting.metadata.ownerPhone}</b></span>
						<span className="ownerMailHeader">מייל: &nbsp;<b>{meeting.metadata.ownerMail}</b></span>
					</div>
					{!meeting.metadata.isSubtitles ? (
						<div className="rowFlex">
							<span className="meetingParticipantsLabel">משתתפים:</span>
							<div className="meetingParticipants">
								{Array.from(speakers).map((person, i) =>
									<div key={i}>
										{i > 0 && <span className="participantHeader">|</span>}
										<b><a
											className="participantHeader"
											onClick={() => setSpeakerToRename(person)}
											style={{ color: IndexedListColorManager.getColorByIndex(i) }} key={i}>
											{person}
										</a></b>
									</div>)}
							</div>
						</div>
					) : null}
				</div>
			</div>
			<div className="columnFlex">
				<div className="rowFlex">
					<Button className="readyButton" onClick={() => {
						const newDate = !meeting?.metadata.dateOfReady ? new Date() : undefined;
						meeting.metadata.dateOfReady = newDate;
						Rx.ChosenMeeting.next({ ...meeting });
						Firebaser.setReady(meeting.metadata.id, meeting.metadata.assignedTo, newDate);
					}} style={{backgroundColor: meeting?.metadata.dateOfReady ? "green" : "red", color: "white", marginLeft: '1em', width: '120px'}}>מוכן לביקורת</Button>
				</div>
				<div className="rowFlex">
					<Button className="deliveredToClient" onClick={() => {
						const shouldSetReady = !meeting?.metadata.dateOfReady;

						meeting.metadata.deliveredToClient = !meeting?.metadata.deliveredToClient;
						if(shouldSetReady)
							meeting.metadata.dateOfReady = new Date();

						Rx.Meetings.next([...Rx.Meetings.value]);

						Firebaser.setDelivered(meeting?.metadata.id, meeting?.metadata.deliveredToClient, meeting?.metadata.assignedTo);
						if(shouldSetReady)
							Firebaser.setReady(meeting?.metadata.id, meeting?.metadata.assignedTo, meeting?.metadata.dateOfReady);
						Rx.ChosenMeeting.next({ ...meeting });
					}} style={{backgroundColor: meeting?.metadata.deliveredToClient ? "green" : "gray", color: "white", marginLeft: '1em', width: '120px'}}>נשלח ללקוח</Button>
				</div>
			</div>

			<Dialog open={!!speakerToRename} onClose={() => setSpeakerToRename('')} onKeyDown={onKeyDown}>
				<DialogTitle>שנה שם מ"{speakerToRename}" ל:</DialogTitle>
				<DialogContent className='renameDialogContent'>
					<TextField value={newName}
							   onChange={e => setNewName(e.target.value as string)}
							   placeholder='הכנס שם חלופי'
							   autoFocus
							   variant='outlined' />
					<Button onClick={onClick} disabled={!newName}>שנה</Button>
				</DialogContent>
			</Dialog>
		</div>
	);
}
